import React, {useEffect, useState} from 'react';
import parent from '../MyModal/MyModal.module.css'
import cl from './FilterModal.module.css'
import close from '../../../Assets/icons/clear.svg'
import Service from "../../../API/Service";
import arrow from '../../../Assets/icons/Vector.svg'

const FilterModal = ({visible, setVisible, filters, setFilters, entity}) => {
    const rootClasses = [parent.myModal]
    const [selectedFilter, setSelectedFilter] = useState(filters.isBlocked);
    const [courseYear, setCourseYear] = useState(filters.courseYear || '');
    const [departmentId, setDepartmentId] = useState(filters.departmentId || '');
    const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
    const [departmentsData, setDepartmentsData] = useState([]);
    const [isFilterActive, setIsFilterActive] = useState(false);

    useEffect(() => {
        setIsFilterActive(selectedFilter !== "" || courseYear !== "" || departmentId !== "");
    }, [selectedFilter, courseYear, departmentId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getTables("departments");
                setDepartmentsData(response.data.content);
            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
            }
        };
        if (entity !== 'admins'){
            fetchData();
        }
    }, []);

    useEffect(() => {
        setDepartmentId(filters.departmentId || '');
    }, [filters.departmentId]);

    if (visible){
        rootClasses.push(parent.active);
    }

    const handleApply = () => {
        setFilters((prev) => ({ ...prev, isBlocked: selectedFilter, courseYear, departmentId }));
        setVisible(false);
    };

    const handleCancel = () => {
        setFilters((prev) => ({ ...prev, isBlocked: '', courseYear: '', departmentId: '' }));
        setSelectedFilter('');
        setCourseYear('');
        setDepartmentId('');
        setVisible(false);
    };

    return (
        <div
            className={rootClasses.join(' ')}
            onClick={() => setVisible(false)}
        >
            <div
                className={parent.myModalContent}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={cl.header}>
                    <h4>Filter</h4>
                    <img src={close} onClick={() => setVisible(false)} alt={"X"}/>
                </div>
                <div className={cl.param}>
                    {entity === 'students' && (
                        <>
                            <label className={cl.input}>
                                Year
                                <input
                                    type="text"
                                    value={courseYear}
                                    onChange={(e) => setCourseYear(e.target.value)}
                                    placeholder="Enter Year"
                                />
                            </label>
                            <label className={cl.input}>
                                Department
                                <div className={cl.dropdownContainer}>
                                    <div
                                        className={`${cl.dropdown} ${departmentId ? cl.selected : ''}`}
                                        onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}
                                    >
                                        {departmentsData.find(dep => dep.id === departmentId)?.name || 'Select Department'}
                                        <img
                                            src={arrow}
                                            alt={"arrow"}
                                            className={showDepartmentDropdown? cl.arrowDown : cl.arrowUp}
                                        />
                                    </div>
                                    {showDepartmentDropdown && (
                                        <div className={cl.dropdownMenu}>
                                            {departmentsData.slice(0, 4).map((dep) => (
                                                <div
                                                    key={dep.id}
                                                    className={cl.dropdownItem}
                                                    onClick={() => {
                                                        setDepartmentId(dep.id);
                                                        setShowDepartmentDropdown(false);
                                                    }}
                                                >
                                                    {dep.name}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </label>
                        </>
                    )}
                    {entity === "teachers" && (
                        <label className={cl.input}>
                            Department
                            <div className={cl.dropdownContainer}>
                                <div
                                    className={`${cl.dropdown} ${departmentId ? cl.selected : ''}`}
                                    onClick={() => setShowDepartmentDropdown(!showDepartmentDropdown)}
                                >
                                    {departmentsData.find(dep => dep.id === departmentId)?.name || 'Select Department'}
                                    <img
                                        src={arrow}
                                        alt={"arrow"}
                                        className={showDepartmentDropdown? cl.arrowDown : cl.arrowUp}
                                    />
                                </div>
                                {showDepartmentDropdown && (
                                    <div className={cl.dropdownMenu}>
                                        {departmentsData.slice(0, 4).map((dep) => (
                                            <div
                                                key={dep.id}
                                                className={cl.dropdownItem}
                                                onClick={() => {
                                                    setDepartmentId(dep.id);
                                                    setShowDepartmentDropdown(false);
                                                }}
                                            >
                                                {dep.name}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </label>
                    )}
                    <label className={cl.radioWrap}>
                        <input
                            type="radio"
                            name="filter"
                            value="true"
                            checked={selectedFilter === "true"}
                            onChange={() => setSelectedFilter("true")}
                        />
                        Blocked users
                    </label>
                    <label className={cl.radioWrap}>
                        <input
                            type="radio"
                            name="filter"
                            value="false"
                            checked={selectedFilter === "false"}
                            onChange={() => setSelectedFilter("false")}
                        />
                        Non-blocked users
                    </label>
                    <div className={cl.filterBtns}>
                        <button
                            className={`${cl.btn} ${isFilterActive ? cl.applyActive : cl.apply}`}
                            disabled={!isFilterActive}
                            onClick={handleApply}
                        >
                            Apply filter
                        </button>
                        <button className={cl.btn} onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default FilterModal;